var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Topbar',{attrs:{"is-menu-opened":_vm.showMobileMenu}}),_c('div',{staticClass:"topnav shadow-sm"}),_c('div',{staticClass:"content-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2)])]),_c('RightSidebar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }